export default {
    '1d-diagram1': {
        'diagram-task': 'Type your answer in the white box.<br>Then click the ‘reveal’ button to see how it compares to the correct answer',
      'diagram-description': `<li>Chickens convey specific information</li>
                                <li>Chickens’ calls refer to specific objects and events</li>
                                <li>Chickens communicate well-thought-out messages</li>
                                <li>Chickens use language the way that people use words</li>`,
        'fixed-answer1': 'Chickens communicate well-thought-out messages',
        'fixed-answer2': 'Convey specific information',
        'fixed-answer3': 'Are tailored to the audience',
        'fixed-answer4': 'Reflect the significance of events',
        'complete-title': 'Reveal',
        'hide-title': 'Hide',
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/1/1d/diagram1/i18n/en.js